import { render, staticRenderFns } from "./RemindersComponent.vue?vue&type=template&id=4114c954&scoped=true&"
import script from "./RemindersComponent.vue?vue&type=script&lang=js&"
export * from "./RemindersComponent.vue?vue&type=script&lang=js&"
import style0 from "./RemindersComponent.vue?vue&type=style&index=0&id=4114c954&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4114c954",
  null
  
)

export default component.exports